<template>
  <vs-tabs position="left" class="tabs-shadow-none">
    <!-- GENERAL -->
    <vs-tab icon-pack="feather" icon="icon-home" label="General">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <general-settings />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-edit" label="Wastage">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <waste-settings />
      </div>
    </vs-tab>
  </vs-tabs>
</template>

<script>
import GeneralSettings from "./GlobalSettings.vue";
import WasteSettings from "./WasteSettings.vue";

import { mapGetters } from "vuex";

export default {
  components: { GeneralSettings, WasteSettings },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({}),
  },
};
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>